import React from "react";
import "./index.scss";
import DeskBar from "./DeskBar";

const NavBar = () => <DeskBar />;

export default NavBar;
